var count = document.querySelectorAll(".menu-unit-detail-list_wrap");

for (let list of count) {
  list.classList.add("is-col" + list.childElementCount);
}
